var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16C2 15.4477 2.44772 15 3 15V15C3.55228 15 4 15.4477 4 16V19H20V16C20 15.4477 20.4477 15 21 15V15C21.5523 15 22 15.4477 22 16V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2929 3.70711C11.6834 3.31658 12.3166 3.31658 12.7071 3.70711L17.2929 8.29289C17.6834 8.68342 17.6834 9.31658 17.2929 9.70711L17.2071 9.79289C16.8166 10.1834 16.1834 10.1834 15.7929 9.79289L13 7V16C13 16.5523 12.5523 17 12 17V17C11.4477 17 11 16.5523 11 16V7L8.20711 9.79289C7.81658 10.1834 7.18342 10.1834 6.79289 9.79289L6.70711 9.70711C6.31658 9.31658 6.31658 8.68342 6.70711 8.29289L11.2929 3.70711Z",
    fill: "white"
  })));
};
export default __webpack_public_path__ + "static/media/export-icon.308385b9.svg";
export { SvgComponent as ReactComponent };